export const createEntityItemId = (entityIds, itemId, identifier) => {
  if (entityIds.length === 0) {
    return itemId;
  }
  return identifier === undefined ? `${entityIds.join('_')}_${itemId}` : `${entityIds.join('_')}_${itemId}#${identifier}`;
};
export const getItemIdIdentifier = (itemId, identifier) => {
  return `${itemId}#${identifier}`;
};
//# sourceMappingURL=create-entity-item-id.js.map